import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  title?: string | JSX.Element;
  text?: string | JSX.Element;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  title,
  text,
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle sx={{ textAlign: "center" }}>
        {title || "Conferma Azione"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {text ?? "Sei sicuro di voler eseguire questa azione?"}
        </DialogContentText>
      </DialogContent>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "60px",
          }}
        >
          <CircularProgress size={24} />
        </Box>
      ) : (
        <>
          <DialogActions>
            <Button onClick={onClose} color="primary">
              Annulla
            </Button>
            <Button onClick={onConfirm} color="primary" disabled={isLoading}>
              Conferma
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default ConfirmationModal;
